import { Form, Formik } from 'formik'
import { Button } from '@components/Buttons'
import { Box } from '@features/profile/components/Box'
import { WriterEnum } from '@interfaces/WriterEnum'
import { ResidenceEnum } from '@interfaces/ResidenceEnum'
import { ScrollToErrorField } from '@components/ScrollToErrorField'
import { AccountingInformation } from './components/AccountingInformation'
import { CoordinatorInformation } from './components/CoordinatorInformation'
import { WriterInformation } from './components/WriterInformation'
import { Address } from './components/Address'
import { DeliveryAddress } from './components/DeliveryAddress'
import { TaxCertificate } from './components/TaxCertificate'
import { BankAccountInformation } from './components/BankAccountInformation'
import { CertificateAddress } from './components/CertificateAddress'
import { Consent } from './components/Consent'
import { UpgradeToWriterProps } from './interface'
import { validationSchema } from './validationSchema'
import { WriterStatus } from './components/WriterStatus'

const residenceOptions = [
  { text: 'ประเทศไทย', value: ResidenceEnum.LOCAL },
  { text: 'ต่างประเทศ', value: ResidenceEnum.ABOARD },
]

export function UpgradeToWriter({
  initialValues,
  isInProgress,
  countryOptions,
  status,
  rejectedReason,
  firstUpgradeToWriter,
  latestConsent,
  handleSubmitForm,
  handleLeavePage,
}: UpgradeToWriterProps) {
  return (
    <div>
      <WriterStatus
        status={status}
        rejectedReason={rejectedReason}
        firstUpgradeToWriter={firstUpgradeToWriter}
      />
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmitForm}
      >
        {({ values, isSubmitting, dirty, resetForm }) => (
          <Form id='upgrade-to-writer'>
            <Box className='mobile:!px-0'>
              <ScrollToErrorField id='upgrade-to-writer' />
              <div className='grid desktop-tablet:gap-[50px] mobile:gap-[30px]'>
                <WriterInformation />
                {values.type === WriterEnum.LEGAL && (
                  <>
                    <CoordinatorInformation />
                    <AccountingInformation />
                  </>
                )}
                {values.type === WriterEnum.INDIVIDUAL ? (
                  <Address
                    residenceOptions={residenceOptions}
                    countryOptions={countryOptions}
                  />
                ) : (
                  <CertificateAddress
                    residenceOptions={residenceOptions}
                    countryOptions={countryOptions}
                  />
                )}
                <DeliveryAddress
                  residenceOptions={residenceOptions}
                  countryOptions={countryOptions}
                />
                <TaxCertificate />
                <BankAccountInformation />
                <Consent
                  className='mobile:mt-[-10px]'
                  status={status}
                  latestConsent={latestConsent}
                />
              </div>
            </Box>

            <div className='flex justify-center space-x-[20px] font-mitr desktop-tablet:mt-[30px] mobile:px-[20px] mobile:mt-[30px]'>
              <Button
                className='w-[100px] mobile:w-[164px] text-[14px] text-secondary-1 border-secondary-1 border-[1px]'
                type='button'
                onClick={() => handleLeavePage(resetForm)}
              >
                ยกเลิก
              </Button>
              <Button
                className='w-[100px] mobile:w-[164px] text-sm bg-primary dark:bg-purple text-white dark:text-white-2'
                type='submit'
                disabled={isInProgress || isSubmitting || !dirty}
              >
                ส่งข้อมูล
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  )
}
